import Vue from 'vue'
// import FastClick from 'fastclick'
import store from './store'
import router from './router'
import App from './App'

// 引入全局插件
import inject from './plugins'
import Vant from 'vant'
//  引入全局图标样式
import '@/assets/platform-font/iconfont.css'
import 'vant/lib/index.css'
// 注入自定义组件和方法
Vue.use(inject)
Vue.use(Vant)
// FastClick.attach(document.body)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

